module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-0 w-1200"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工具名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入工具名称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工具地址",
      "prop": "url"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入工具地址"
    },
    model: {
      value: (_vm.form.url),
      callback: function($$v) {
        _vm.$set(_vm.form, "url", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b0f79de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/development/edit.vue
// module id = 1816
// module chunks = 2